<template>
  <div class="screen-container">
    <div class="relative-flex-box">
      <div class="left-align-box">
        <p>どのロボ社員を雇用しますか？</p>
      </div>
      <!-- ロボ検索(ロボ名またはタグ) -->
      <div class="right-align-box">
        <input class="input input-w400" placeholder="🔎ロボ名またはタグ名で検索" v-model="searchWords"/>
      </div>
    </div>
    <div v-if="isLoading">
      <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
    </div>
    <div v-else>
      <div class="tag-button-box" v-show="getTagDataList.length">
        <div class="tag-button" v-for="(tagButton, tagButtonIndex) in getTagDataList" :key="tagButtonIndex">
          <a
            :class="{
              'button is-small is-primary' : tagButton.isSelect === true,
              'button button-unselect is-small is-primary' : tagButton.isSelect === false,
            }"
            @click="tagSelect(tagButton.name)"
          >
            {{tagButton.name}}
          </a>
        </div>
      </div>
      <div class="template-list disp-scroll" v-if="getTagDataList.length > 0">
        <div v-for="(tagBox, tagBoxIndex) in getTagDataList" :key="tagBox.name + '-' + tagBoxIndex">
          <div class="relative-flex-box" v-if="tagBox.isSelect === true">
            <!-- タグ名とロボ台数 -->
            <div class="left-align-box">
              <!-- タグ名 -->
              {{tagBox.name}}
              <!-- ロボ台数 -->
              <b-tag rounded>
                {{getTemplateTotalNum(tagBox)}}
              </b-tag>
            </div>
            <!-- 全て表示ボタン -->
            <div class="right-align-box">
              <button
                class="button"
                v-show="tagBox.templateTotalNum > TEMPLATE_DISP_INI"
                v-if="!tagBox.isShowAll"
                @click="showAll(tagBox.name)"
              >
                全て表示
              </button>
              <button
                class="button"
                v-show="tagBox.templateTotalNum > TEMPLATE_DISP_INI"
                v-if="tagBox.isShowAll"
                @click="showAll(tagBox.name)"
              >
                表示を減らす
              </button>
            </div>
          </div>
          <!-- ロボカード -->
          <div
            v-if="tagBox.isSelect === true"
            class="template-card-box"
          >
            <RoboCard
              v-for="template in getDispTemplateList(tagBox, 'disp-robo')" :key="template.bot_id + '-' + tagBox.name"
              class="template-card"
              parent="template-list"
              :robo="template"
              :PCTRLLOG="CTRLLOG"
            />
          </div>
        </div>
      </div>
      <div class="list-nothing-message" v-else>
        表示できるロボがありませんでした。
      </div>
    </div>
  </div>
</template>

<script>
import { mapState }        from 'vuex'
import RoboCard            from '@/components2/Robo/modal/RoboCard'
import ModalChatBotDetails from '@/components/ChatBot/organisms/ModalChatBotDetails'
import controlLogMixin     from '@/mixins/controlLogMixin'
import {
  isRoboDisplayPermission
} from '@/functions/checkPermission'

export default {
  name: 'RoboTemplateList',
  componentName: 'RoboTemplateList',
  components: {
    RoboCard,
    ModalChatBotDetails,
    isRoboDisplayPermission
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      TEMPLATE_DISP_INI: 4,
      /**
       * コンポーネント名
       * @type {String}
       */
      COMPONENT_NAME: 'RoboTemplateList',
      /**
       * 読み込み中フラグ
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * タブごとの表示テンプレートロボリストセット
       * @type {Object}
       */
      dispTemplateListSet: {},
      /**
       * 検索ワード
       * @type {String}
       */
      searchWords: null,
      /**
       * タグ名リスト
       * @type {Array}
       */
      tagDataList: {},
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['templateRobo']),
    /**
     * タグデータリスト取得
     */
    getTagDataList () {
      let tagList = []
      const keyList = Object.keys(this.tagDataList)
      for (let key of keyList) {
        tagList.push(this.tagDataList[key])
      }
      return tagList
    },
  },
  mounted () {
    // テンプレートロボ取得
    this.isLoading = true
    this.$store.dispatch('chatbot/getTemplateRobo')
  },
  watch: {
    templateRobo () {
      this.templateInit()
      this.isLoading = false
    }
  },
  methods: {
    /**
     * テンプレートロボ一覧初期化
     */
    templateInit () {
      // 表示するタグの一覧を作成
      let deduplicationTgList = []
      this.dispTemplateListSet = {}

      if (this.templateRobo.length > 0) {
        // テンプレートロボの持っているタグを一覧化して重複削除
        let tagList = []
        let tags = this.templateRobo.map(
          robo => {
            if (robo.chatbot_tag.length > 0) {
              return robo.chatbot_tag.map( tag => {return tag.name})
            } else {
              return 'タグ未設定'
            }
          }
        )
        for (let tag of tags) {
          if (typeof(tag) == 'object') {
            tagList = tagList.concat(tag)
          } else {
            tagList.push(tag)
          }
        }

        // タグ名の重複を削除
        tagList = Array.from(new Set(tagList))
        // タグ情報初期化
        for (let tag of tagList) {
          deduplicationTgList[tag] = {
            name: tag,
            templateTotalNum: 0,
            templateDispNum: this.TEMPLATE_DISP_INI,
            isShowAll: false,
            isSelect: true
          }
        }

        // タグごとにロボを分ける
        const keyList = Object.keys(deduplicationTgList)
        for (let key of keyList) {
          if (deduplicationTgList[key].name === 'タグ未設定') {
            this.dispTemplateListSet[key] = this.templateRobo.filter(
              robo => robo.chatbot_tag.length === 0
            )
          } else {
            this.dispTemplateListSet[key] = this.templateRobo.filter(
              robo => robo.chatbot_tag.filter(tag => tag.name === key).length > 0
            )
          }
          // タグごとのロボ台数設定
          deduplicationTgList[key].templateTotalNum = this.dispTemplateListSet[key].length
        }

        // タグ未設定ロボが無ければ削除
        if (this.dispTemplateListSet['タグ未設定']) {
          delete this.dispTemplateListSet['タグ未設定']
          delete deduplicationTgList['タグ未設定']
        }
      }
      this.tagDataList = deduplicationTgList
    },
    /**
     * タグに所属するテンプレートロボを全て表示
     * @param {String} tagName タグ名
     */
    showAll (tagName) {
      let buf = {}
      const keyList = Object.keys(this.tagDataList)
      for (let key of keyList) {
        buf[key] = JSON.parse(JSON.stringify(this.tagDataList[key]))
      }
      buf[tagName].isShowAll = !buf[tagName].isShowAll
      this.tagDataList = {}
      this.tagDataList = buf
    },
    /**
     * タグを選択
     * @param {String} tagName タグ名
     */
    tagSelect (tagName) {
      let buf = {}
      const keyList = Object.keys(this.tagDataList)
      for (let key of keyList) {
        buf[key] = JSON.parse(JSON.stringify(this.tagDataList[key]))
      }
      buf[tagName].isSelect = !buf[tagName].isSelect
      this.tagDataList = {}
      this.tagDataList = buf
    },
    /**
     * タグごとに表示されるロボ取得
     * @param {String} tagData タグ情報
     * @return {Array}
     */
    getTemplateTotalNum (tagData) {
      const template_list = this.getDispTemplateList(tagData, 'total-num')
      return template_list.length
    },
    /**
     * タグごとに表示されるロボ取得
     * @param  {String} tagData タグ情報
     * @return {Array} ロボリスト
     */
    getDispTemplateList (tagData, getMode) {
      let findTemplateList = []
      let templateList = this.dispTemplateListSet[tagData.name]
      if (templateList) {
        findTemplateList = templateList.filter(template => template.is_template === true)
        if (this.searchWords) {
          findTemplateList = findTemplateList.filter(
            robo =>
            // ロボ管理名に部分一致
            robo.name.indexOf(this.searchWords) >= 0 ||
            // ロボ表示名に部分一致
            (robo.display_name && robo.display_name.indexOf(this.searchWords) >= 0) ||
            // 付与されているタグ名に部分一致
            (robo.chatbot_tag && robo.chatbot_tag.find(tag => tag.name.indexOf(this.searchWords) >= 0))
          )
        } else {
          findTemplateList = templateList
        }
      }
      if (getMode === 'disp-robo') {
        if (tagData.isShowAll === false) {
          // 全表示ではない場合、4台のみ表示
          findTemplateList = findTemplateList.slice(0, this.TEMPLATE_DISP_INI)
        }
      }

      return findTemplateList
    },
  },
}
</script>

<style lang="scss" scoped>
.screen-container {
  width: 100%;
  height: auto;
}
.-container {
  width : 100%;
  padding: 4px 16px;
}
.alert-box {
  display: flex;
}
// 検索
.relative-flex-box {
  width: 100%;
  padding: 8px;
  display: flex;
  // justify-content: center;
  // position: relative;
  align-items: flex-start;
  // 要素左寄せ
  .left-align-box {
    margin-right: auto;
    padding-right: 16px;
  }
  // 要素中央寄せ
  .center-align-box {
    margin-left: auto;
    margin-right: auto;
    padding-left: 8px;
    padding-right: 8px;
  }
  // 要素右寄せ
  .right-align-box {
    margin-left: auto;
    padding-left: 16px;
  }
}
.tag-button-box {
  width: 100%;
  display: flex;
  justify-content: left;
  position: relative;
  // 要素左寄せ
  .tag-button {
    padding: 8px;
  }
}
.button-unselect {
  background: gray !important;
}
.template-list {
  height: calc(100vh - 102px);
}
.template-card-box {
  width: 100%;
  display: flex;
  justify-content: left;
  position: relative;
  flex-wrap: wrap;
  // 要素左寄せ
  .template-card {
    height: auto;
    padding: 8px;
  }
}
.input-w400 {
  width: 400px;
}
// リスト無しメッセージ
.list-nothing-message {
  position: fixed;
  padding: 12px;
  font-size: 20px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/screen/RoboTemplateList.vue